<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: null,
    },
  },
  methods: {
    handleSelect(item) {
      this.$emit('select', item)
    },
  },
}
</script>

<template>
  <div :class="$style.dropdown" v-on="$listeners">
    <div
      v-for="item in list"
      :key="item.name"
      :class="$style.item"
      ontouchstart=""
      @click="handleSelect(item)"
    >
      {{ item.name }}
    </div>
    <div v-if="!list.length" :class="$style.item">No locations found</div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.dropdown {
  background: var(--color-white);
  border: 2px solid var(--color-primary);
  position: relative;

  &:before {
    background-size: cover;
    border-bottom: 10px solid var(--color-primary);
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    content: '';
    height: 0;
    position: absolute;
    top: -10px;
    width: 0;
  }

  &:after {
    background-size: cover;
    border-bottom: 10px solid var(--color-white);
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    content: '';
    height: 0;
    position: absolute;
    top: -6px;
    width: 0;
  }
}

.item {
  border-bottom: 2px solid $color-text-disabled;
  margin: 0;
  padding: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;

  &:last-child {
    border: 0;
  }
}
</style>
